export default __webpack_public_path__ + "static/media/faceD-victory.e1351f9f.png";